import SrMessage from "./SrMessage.vue";

SrMessage.install = function(Vue) {
  Vue.component(SrMessage.name, SrMessage);
};

export default SrMessage;


// WEBPACK FOOTER //
// ./packages/SrMessage/index.js